export default function FeaturesSection() {
  const items = [
    {
      icon: 'ri-shield-check-line',
      title: '全程免广告',
      desc: '拒绝片头、片中、弹窗等一切广告形式，纯净观影体验，不中断你的每一分钟沉浸时光。',
    },
    {
      icon: 'ri-4k-line',
      title: '高清蓝光画质',
      desc: '支持 1080P 至 4K 蓝光画质，HDR 色彩优化技术，让每一帧都如影院般震撼呈现。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载不缓冲',
      desc: '全球 CDN 加速节点覆盖，自适应码率传输，确保观影流畅不卡顿，无需等待缓冲。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日片库更新',
      desc: '专业编辑团队每日精选最新院线大片和高分电影入库，让好片不等待，精彩持续上映。',
    },
  ];

  return (
    <section id="features" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          平台优势
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center max-w-[500px] mx-auto">
          为什么影迷们都选择天堂影视在线观影
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-colors"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 font-heading mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}